
<b-modal
    id="local"
    title="Lokal tolkning"
    size="lg"
    hide-footer
    hide-backdrop
    hide-header
    return-focus=".ql-editor"
    no-fade
    @show="openModal"
    @keydown.esc="closeModal"
    @hide="closeModal"
>
    <h3>Lokal tolkning</h3>
    <b-overlay :show="remotesession" rounded="sm">
        <template #overlay>
            <div class="text-center">
                <b-icon
                    icon="exclamation-circle-fill"
                    font-scale="3"
                    animation="cylon"
                ></b-icon>
                <p class="lead">
                    Du är redan ansluten till en distanstolkning.
                </p>
            </div>
        </template>
        <b-card
            header="Tolkning på lokalt nätverk"
            sub-title="Låt andra enheter ansluta till STTylus och ta del av texten"
        >
            <b-card-text v-if="ip">
                <div v-if="local">
                    Andra enheter på nätverket ansluter till:
                    <br />
                    <br />
                    <h4>http://{{ ip }}/</h4>
                    <br />
                    <b-button variant="danger" @click="stopLocal"
                        >Avsluta</b-button
                    >
                </div>
                <div v-else>
                    <b-button @click="startLocal">Starta</b-button>
                </div>
            </b-card-text>

            <b-card-text v-else>
                <b>Du är inte ansluten till ett lokalt nätverk.</b>
                <br />
                <b-button @click="checkConnection" variant="info"
                    >Uppdatera</b-button
                >
            </b-card-text>
        </b-card>
        <b-card
            header="Tolkning på projektorduk eller extern skärm"
            sub-title="Öpnnar en ruta som visar texten utan distraktioner, som kan visas på en annan skärm"
        >
            <b-card-text>
                <div v-if="!presentation">
                    <b-button @click="startPresentation">Utvidga</b-button>
                </div>
                <div v-else>
                    {{ window }}
                    <b-button @click="stopPresentation">Stäng</b-button>
                </div>
            </b-card-text>
        </b-card>
    </b-overlay>
</b-modal>
